import DOMPurify from 'dompurify';

// Converts the assistant's lightweight markdown (bold + newlines) to sanitized HTML.
export const mdToSafeHtml = (text) =>
  DOMPurify.sanitize(
    (text || '').replace(/\*\*(.*?)\*\*/g, '<strong>$1</strong>').replace(/\n/g, '<br/>'),
    { ALLOWED_TAGS: ['strong', 'em', 'br'] }
  );
